import { mapActions, mapGetters } from 'vuex'

const filtrosMixin = {
  data: () => {
    return {
      contexto: null
    }
  },
  computed: {
    ...mapGetters('filtros', ['obterFiltro', 'obterFiltros', 'obterOrdenacao', 'obterOrdenacoes'])
  },
  methods: {
    ...mapActions('filtros', ['ActionSalvarFiltros', 'ActionLimparFiltros', 'ActionSalvarOrdenacao', 'ActionLimparOrdenacao']),
    definirContexto (contexto) {
      this.contexto = contexto
    },

    inicializarFiltrosPesquisa (camposFiltroPesquisa) {
      const filtros = {}

      for (const campo in camposFiltroPesquisa) {
        const valorPadraoFiltro = camposFiltroPesquisa[campo]
        filtros[campo] = this.obterFiltro(this.contexto, campo, valorPadraoFiltro)
      }

      return filtros
    },
    salvarFiltrosPesquisa (filtros) {
      this.ActionSalvarFiltros({ contexto: this.contexto, filtros })
    },

    obterFiltroPesquisa (campo, valorPadrao = null) {
      return this.obterFiltro(this.contexto, campo, valorPadrao)
    },

    obterFiltrosPesquisa () {
      return this.obterFiltros(this.contexto)
    },

    limparFiltrosPesquisa () {
      this.ActionLimparFiltros(this.contexto)
    },

    inicializarComponenteOrdenacao (componenteOrdenacao) {
      const ordenacao = {}

      for (const campo in componenteOrdenacao) {
        const valorPadraoOrdenacao = componenteOrdenacao[campo]
        ordenacao[campo] = this.obterOrdenacao(this.contexto, campo, valorPadraoOrdenacao)
      }

      return ordenacao
    },

    salvarComponenteOrdenacao (ordenacao) {
      this.ActionSalvarOrdenacao({ contexto: this.contexto, ordenacao })
    },

    obterComponenteOrdenacao (campo, valorPadrao = null) {
      return this.obterOrdenacao(this.contexto, campo, valorPadrao)
    },

    limparComponenteOrdenacao () {
      this.ActionLimparOrdenacao(this.contexto)
    }
  }
}

export { filtrosMixin }
